import { Typography } from '../../styles';

import { StyledText } from './Styled';

const H1 = (props) => {
    return (
        <StyledText
            font={Typography.h1.fontFamily}
            size={Typography.h1.fontSize}
            color={Typography.h1.color}
            {...props}
        >
            {props.children}
        </StyledText>
    );
};

export default H1;
